import ApiService from '@/services/api.service'

const NursingUnitService = {
    getAll( ) {    
      return ApiService.get('/NursingUnits');      
    },
  
    get(id) {
      return ApiService.get(`/NursingUnits/${id}`);
    },    
  }
  
  export default NursingUnitService;